// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"053d056d","219":"8b40714a","359":"c47eea29","453":"80d31e87","625":"4de70a9a","654":"7481840f","729":"ad029655","848":"3e99eefe","976":"0bd653bf","988":"3f00b338"}[chunkId] + ".chunk.js";
};